import { Box } from '@chakra-ui/react';
import { ExternalLayout } from '@melio/penny';
import { PlaidAccountData } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { AddPlaidAccount } from '../components';

export type AddPlaidFundingSourceScreenProps = {
  onClose?: VoidFunction;
  onError?: ErrorFunction;
  onSuccess: (data: PlaidAccountData) => void;
  billId?: string;
};

export const AddPlaidFundingSourceScreen = forwardRef<AddPlaidFundingSourceScreenProps, 'iframe'>(
  ({ billId, onClose, onError, onSuccess, children, ...props }, ref) => (
    <Box data-component={AddPlaidFundingSourceScreen.displayName} {...props} ref={ref}>
      <ExternalLayout isLoading />
      <AddPlaidAccount onSuccess={onSuccess} onExit={onClose} onError={onError} />
    </Box>
  )
);

AddPlaidFundingSourceScreen.displayName = 'AddPlaidFundingSourceScreen';
